const smsLongcodeFields = [
  {
    label: 'Code',
    key: 'code',
    requireMapping: true,
    validators: [{ validate: 'unique' }],
  },
  {
    label: 'Mailing Name',
    key: 'mailing_name',
  },
  {
    label: 'Version',
    key: 'version',
  },
  {
    label: 'Vendor',
    key: 'channel',
    type: 'select',
    selectOptions: [
      {
        label: 'Blue Action',
        value: 'Blue Action',
        alternateMatches: ['blue action', 'Blue action', 'BLUE ACTION', 'blue Action'],
      },
      {
        label: 'Durable',
        value: 'Durable',
        alternateMatches: ['durable', 'DURABLE'],
      },
      {
        label: 'Grassroots Analytics',
        value: 'Grassroots Analytics',
        alternateMatches: ['grassroots analytics', 'Grassroots analytics', 'GRASSROOTS ANALYTICS', 'grassroots Analytics'],
      },
      {
        label: 'Hockeystick',
        value: 'Hockeystick',
        alternateMatches: ['hockeystick', 'HOCKEYSTICK'],
      },
      {
        label: 'HouseFile',
        value: 'HouseFile',
        alternateMatches: ['housefile', 'HOUSEFILE', 'Housefile'],
      },
      {
        label: 'Leverage',
        value: 'Leverage',
        alternateMatches: ['leverage', 'LEVERAGE'],
      },
      {
        label: 'Message Digital',
        value: 'Message Digital',
        alternateMatches: ['message digital', 'MESSAGE DIGITAL', 'message Digital', 'Message digital'],
      },
      {
        label: 'MissionSMS',
        value: 'MissionSMS',
        alternateMatches: ['missionsms', 'MISSIONSMS', 'missionSMS', 'Mission SMS'],
      },
      {
        label: 'Mobile Commons',
        value: 'Mobile Commons',
        alternateMatches: ['mobile commons', 'MOBILE COMMONS', 'Mobile commons', 'mobile Commons'],
      },
      {
        label: 'ROI/Ripple',
        value: 'ROI/Ripple',
        alternateMatches: ['roi/ripple', 'ROI/RIPPLE', 'Roi/Ripple'],
      },
      {
        label: 'Scale to Win',
        value: 'Scale to Win',
        alternateMatches: ['scale to win', 'SCALE TO WIN', 'Scale to win', 'scale To Win'],
      },
      {
        label: 'Sterling',
        value: 'Sterling',
        alternateMatches: ['sterling', 'STERLING'],
      },
      {
        label: 'Strive',
        value: 'Strive',
        alternateMatches: ['strive', 'STRIVE'],
      },
      {
        label: 'Switchboard',
        value: 'Switchboard',
        alternateMatches: ['switchboard', 'SWITCHBOARD'],
      },
      {
        label: 'Tatango',
        value: 'Tatango',
        alternateMatches: ['tatango', 'TATANGO'],
      },
      {
        label: 'Textify',
        value: 'Textify',
        alternateMatches: ['textify', 'TEXTIFY'],
      },
      {
        label: 'Other',
        value: 'Other',
        alternateMatches: ['other', 'OTHER'],
      },
    ],
  },
  {
    label: 'Jira Ticket Number',
    key: 'jira_ticket_num',
    description: 'If Vendor is MissionSMS, Jira Ticket Number is required and must be in format ABC123',
    validators: [
      {
        validate: 'require_with_values',
        fieldValues: {
          channel: 'MissionSMS',
        },
        errorMessage: 'Jira Ticket Number is required when Vendor is MissionSMS',
      },
      {
        validate: 'regex_match',
        regex: '^[A-Z]+\\d+$',
        errorMessage: 'Jira Ticket Number must be in format ABC123',
      },
    ],
  },
  {
    label: 'Send Date',
    key: 'send_date',
    type: ['date', {
      autofix: true,
    }],
  },
  {
    label: 'Send Cost',
    key: 'send_cost',
    type: ['number', {
      preset: 'decimal_2',
      min: 0,
    }],
  },
  {
    label: 'Send Size',
    key: 'send_size',
    type: ['number', {
      preset: 'integer',
      min: 0,
    }],
  },
];

const importExclusionsFields = [
  {
    label: 'Recipient ID',
    key: 'recipientId',
    requireMapping: true,
  },
  {
    label: 'Lineitem ID',
    key: 'lineItemId',
    requireMapping: true,
  },
  {
    label: 'Exclude Flag',
    key: 'exclude_flag',
    requireMapping: true,
  },
];

export {
  smsLongcodeFields,
  importExclusionsFields,
};
